export { default } from './ConditionDetailCard';
